import {Component, OnInit, Input} from '@angular/core';
import { InventoryInputModel } from '../inventory-input.model';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { Model_SoudotecDocumentLigne } from '../../soudotec.models';

@Component({
    selector: 'abw-inventory-input-result',
    templateUrl: './inventory-input-result.component.html',
    styleUrls: ['./inventory-input-result.component.scss']
})
export class InventoryInputResultComponent implements OnInit {
	@Input() model: InventoryInputModel;
    @Input() value: Model_SoudotecDocumentLigne[];
    component: Model_WorkflowComponent;
    valueName: string;
    displayName: string;
    qrCodeName: string;

    constructor() {
    }

    ngOnInit() {
        this.component = this.model.additional as Model_WorkflowComponent;
        this.valueName = this.component.VALUE_COLUMN_NAME;
        this.displayName = this.component.DISPLAY_COLUMN_NAME;
        this.qrCodeName = (this.component as any).QRCODE_COLUMN_NAME;
    }

    exportToCsv() {
        if (!!this.value) {
            const rows = this.value.map(v => ([v.AR_Ref, v.ABW_QuantiteSaisie]));
            let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join("\t")).join("\n");
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `${this.model.id}.txt`);
            document.body.appendChild(link); // Required for FF

            link.click();
        }
    }
}